import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Opens the Loads page with the given load in the detail modal (via location.state.openLoadId).
 */
const LoadTicketLink = ({ loadId, ticketNumber, className = '' }) => {
  if (!loadId) {
    return <span className="text-gray-400">—</span>;
  }
  if (!ticketNumber) {
    return <span className="text-gray-400">—</span>;
  }
  return (
    <Link
      to="/loads"
      state={{ openLoadId: loadId }}
      className={`font-mono text-blue-700 hover:underline ${className}`}
    >
      {ticketNumber}
    </Link>
  );
};

export default LoadTicketLink;
